import apiInstance from "@/api/axiosInstance";

import {
  type RequestConfigCreateExchange,
  type RequestConfigGetAllExchange,
  type RequestConfigGetExchange,
  type RequestConfigGetListSbp,
  type RequestConfigGetRate,
  type ResoponseCreateExchange,
  type ResponseAllExchanges,
  type ResponseExchange,
  type ResponseListSbp,
  type ResponseRate,
} from "../types/exchange.types";

export const EXCHANGE_API = {
  getAllExchange: async ({
    params,
    config,
  }: RequestConfigGetAllExchange): Promise<ResponseAllExchanges> => {
    const queryParams = new URLSearchParams();
    if (params?.page) {
      queryParams.append("page", params.page.toString());
    }

    if (params?.limit) {
      queryParams.append("limit", params.limit.toString());
    }

    const response = await apiInstance.get<ResponseAllExchanges>(
      `/exchange?${queryParams.toString()}`,
      { signal: config?.signal },
    );

    return response.data;
  },
  getExchange: async ({
    params,
    config,
  }: RequestConfigGetExchange): Promise<ResponseExchange> => {
    const response = await apiInstance.get<ResponseExchange>(
      `/exchange/${params.id}`,
      { signal: config?.signal },
    );

    return response.data;
  },
  getRecentWallets: async (): Promise<{ data: string[] }> => {
    const response = await apiInstance.get<{ data: string[] }>(
      `/exchange/recent-wallets`,
    );

    return response.data;
  },
  creteExchange: async ({
    params,
    config,
  }: RequestConfigCreateExchange): Promise<ResoponseCreateExchange> => {
    const response = await apiInstance.post<ResoponseCreateExchange>(
      `/exchange/create`,
      params,
      config,
    );

    return response.data;
  },
  getListSbp: async ({ params, config }: RequestConfigGetListSbp) => {
    const queryParams = new URLSearchParams();

    if (params.isDrActive) {
      queryParams.set("isDrActive", String(params.isDrActive));
    }

    const response = await apiInstance.get<ResponseListSbp>(
      `/exchange/list-sbp?${queryParams}`,
      {
        signal: config?.signal,
      },
    );
    return response.data;
  },
  getRate: async ({ params, config }: RequestConfigGetRate) => {
    const queryParams = new URLSearchParams();

    if (params?.amount_from) {
      queryParams.append("amount_from", params.amount_from.toString());
    }
    if (params?.amount_to) {
      queryParams.append("amount_to", params.amount_to.toString());
    }
    if (params?.currency_from) {
      queryParams.append("currency_from", params.currency_from.toString());
    }
    if (params?.currency_to) {
      queryParams.append("currency_to", params.currency_to.toString());
    }

    const response = await apiInstance.get<ResponseRate>(
      `/rate?${queryParams}`,
      {
        signal: config?.signal,
      },
    );

    return response.data;
  },
};
